import { Injectable } from "@angular/core";

@Injectable({ providedIn: "root" })
export class IsLocalhostGuard {
	canActivate(): boolean {
		return window.location.hostname === "localhost";
	}
}
